export const urlCoreBack = import.meta.env.VITE_CORE_BACK;
export const systemCode = import.meta.env.VITE_SYSTEM_CODE || "gestion-comercial";
export const systemName = import.meta.env.VITE_SYSTEM_NAME || "Gestión Comercial";